import React, { ReactElement } from "react";
import { FOOTCONTENT } from "../utils/Enum";
import privacyChoice from "../../public/images/svg/privacyChoices.svg";

export default function Footer(): ReactElement {
  const year = new Date().getFullYear();
  const yearToday = 2025;
  const COPYRIGHT =
    year === yearToday
      ? `© 2025 Costco Wholesale Corporation. All rights reserved.`
      : `© 2025 - ${year} Costco Wholesale Corporation. All rights reserved.`;

  const render = () => (
    <footer className="flex-none font-normal w-full bg-blue-600 border-t border-blue-600/50 text-white flex flex-col space-y-4 text-center py-4">
      <div
        id="footer-sections"
        className="flex flex-col font-light mx-auto mt-4 space-y-2 md:space-y-0 md:flex-row md:space-x-6"
      >
        <a
          href="https://www.costco.com/terms-and-conditions-of-use.html"
          rel="noreferrer"
          target="_blank"
          className="px-4 py-3"
        >
          {FOOTCONTENT.TERMS}
        </a>
        <a
          href="https://www.costco.com/privacy-policy.html"
          rel="noreferrer"
          target="_blank"
          className="px-4 py-3"
        >
          {FOOTCONTENT.PRIVACY_RIGHTS}
        </a>
        {FOOTCONTENT.CA_NOTICE && (
          <a
            href="https://www.costco.com/privacy-policy.html#cppa"
            rel="noreferrer"
            target="_blank"
            className="px-4 py-3"
          >
            {FOOTCONTENT.CA_NOTICE}
          </a>
        )}
        {FOOTCONTENT.PRIVACY_CHOICES && (
          <div className="flex space-x-4 px-4 py-3">
            <img
              className="h-3 mt-1.5 pointer shadow-border"
              alt="Cookie Settings"
              src={privacyChoice}
            />
            <a
              href="https://www.costco.com/DNSMIView"
              rel="noreferrer"
              target="_blank"
              className="font-normal"
            >
              {FOOTCONTENT.PRIVACY_CHOICES}
            </a>
          </div>
        )}
      </div>
      <div id="copyright-section" className="text-sm pb-8 md:pb-0">
        {COPYRIGHT}
      </div>
    </footer>
  );

  return render();
}
